import { render, staticRenderFns } from "./CidadeDataTable.vue?vue&type=template&id=c19ad3b2"
import script from "./CidadeDataTable.vue?vue&type=script&lang=js"
export * from "./CidadeDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports